/**
 * Contrôles de format des coordonnées de contact de facturation, alignés sur ceux du back
 * (FinancierService : value objects `EmailContactFacturation` et `TelephoneContactFacturation`).
 */

/** Exige une extension de domaine d'au moins 2 caractères (`contact@axess` est refusé). */
const FORMAT_EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s.]{2,}$/;
/** Préfixe international facultatif (+33, +32...), puis chiffres et séparateurs usuels. */
const FORMAT_TELEPHONE = /^\+?[0-9 .\-()]+$/;
const TELEPHONE_CHIFFRES_MIN = 6;
const TELEPHONE_CHIFFRES_MAX = 15;

export function estEmailValide(email: string | null | undefined): boolean {
  return FORMAT_EMAIL.test((email ?? '').trim());
}

/** Numéro national ou international, de 6 à 15 chiffres. */
export function estTelephoneValide(telephone: string | null | undefined): boolean {
  const valeur = (telephone ?? '').trim();
  const nombreChiffres = valeur.replace(/\D/g, '').length;
  return FORMAT_TELEPHONE.test(valeur)
    && nombreChiffres >= TELEPHONE_CHIFFRES_MIN
    && nombreChiffres <= TELEPHONE_CHIFFRES_MAX;
}
